"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleAuth = void 0;
const errors_1 = require("../util/errors");
class SimpleAuth {
    constructor(token, tokenTypeOrOptions) {
        if (!token) {
            throw new errors_1.ConfigurationError(`${this.constructor.name} needs to be initialized with a token to be used`);
        }
        this.token = token;
        if (isOptionsArg(tokenTypeOrOptions)) {
            this.tokenType = tokenTypeOrOptions.tokenType || 'Bearer';
            this.claims = tokenTypeOrOptions.claims || {};
        }
        else {
            this.tokenType = tokenTypeOrOptions || 'Bearer';
            this.claims = {};
        }
    }
    async getToken() {
        return await this.token;
    }
    async getTokenType() {
        return await this.tokenType;
    }
    async getClaim(claim) {
        if (claim in this.claims) {
            return this.claims[claim];
        }
        throw new errors_1.ConfigurationError(`${this.constructor.name}.getClaim('${claim}') was called, but claim was undefined`);
    }
}
exports.SimpleAuth = SimpleAuth;
function isOptionsArg(options) {
    return typeof options === 'object' && !('then' in options);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2ltcGxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2F1dGgvc2ltcGxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDJDQUFvRDtBQVNwRCxNQUFNLFVBQVU7SUFLZCxZQUNFLEtBQStCLEVBQy9CLGtCQUFpRTtRQUVqRSxJQUFJLENBQUMsS0FBSyxFQUFFO1lBQ1YsTUFBTSxJQUFJLDJCQUFrQixDQUMxQixHQUFHLElBQUksQ0FBQyxXQUFXLENBQUMsSUFBSSxrREFBa0QsQ0FDM0UsQ0FBQztTQUNIO1FBQ0QsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUM7UUFDbkIsSUFBSSxZQUFZLENBQUMsa0JBQWtCLENBQUMsRUFBRTtZQUNwQyxJQUFJLENBQUMsU0FBUyxHQUFHLGtCQUFrQixDQUFDLFNBQVMsSUFBSSxRQUFRLENBQUM7WUFDMUQsSUFBSSxDQUFDLE1BQU0sR0FBRyxrQkFBa0IsQ0FBQyxNQUFNLElBQUksRUFBRSxDQUFDO1NBQy9DO2FBQU07WUFDTCxJQUFJLENBQUMsU0FBUyxHQUFHLGtCQUFrQixJQUFJLFFBQVEsQ0FBQztZQUNoRCxJQUFJLENBQUMsTUFBTSxHQUFHLEVBQUUsQ0FBQztTQUNsQjtJQUNILENBQUM7SUFDRCxLQUFLLENBQUMsUUFBUTtRQUNaLE9BQU8sTUFBTSxJQUFJLENBQUMsS0FBSyxDQUFDO0lBQzFCLENBQUM7SUFFRCxLQUFLLENBQUMsWUFBWTtRQUNoQixPQUFPLE1BQU0sSUFBSSxDQUFDLFNBQVMsQ0FBQztJQUM5QixDQUFDO0lBRUQsS0FBSyxDQUFDLFFBQVEsQ0FBSSxLQUFhO1FBQzdCLElBQUksS0FBSyxJQUFJLElBQUksQ0FBQyxNQUFNLEVBQUU7WUFDeEIsT0FBTyxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBTSxDQUFDO1NBQ2hDO1FBQ0QsTUFBTSxJQUFJLDJCQUFrQixDQUMxQixHQUFHLElBQUksQ0FBQyxXQUFXLENBQUMsSUFBSSxjQUFjLEtBQUssd0NBQXdDLENBQ3BGLENBQUM7SUFDSixDQUFDO0NBQ0Y7QUFRUSxnQ0FBVTtBQU5uQixTQUFTLFlBQVksQ0FDbkIsT0FBcUQ7SUFFckQsT0FBTyxPQUFPLE9BQU8sS0FBSyxRQUFRLElBQUksQ0FBQyxDQUFDLE1BQU0sSUFBSSxPQUFPLENBQUMsQ0FBQztBQUM3RCxDQUFDIn0=